import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { testimonials } from '@/mocks/homeData';

export default function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section ref={ref} className="relative bg-background-50 py-24 md:py-32 lg:py-40 overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-primary-50/25 -translate-y-1/2 blur-3xl pointer-events-none" />

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="text-center max-w-[600px] mx-auto mb-16 md:mb-20">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-xs tracking-[0.2em] uppercase text-primary-400 font-label"
          >
            Depoimentos
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground-950 mt-4 leading-[1.1]"
          >
            O que nossas<br />
            <span className="italic font-light">pacientes dizem.</span>
          </motion.h2>
        </div>

        {/* Grid lado a lado */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {testimonials.map((t, index) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.08 + index * 0.06, ease: [0.25, 0.1, 0.25, 1] }}
              className="group relative bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 transition-all duration-400 hover:border-primary-200/60 hover:shadow-[0_15px_50px_-15px_rgba(139,126,197,0.10)]"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-accent-400">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-foreground-700 text-sm leading-relaxed italic mb-5">
                &ldquo;{t.text}&rdquo;
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 text-xs font-semibold font-label">
                    {t.name.split(' ')[0][0]}{t.name.split(' ').slice(-1)[0][0]}
                  </span>
                </div>
                <div>
                  <p className="text-xs text-foreground-900 font-semibold font-label whitespace-nowrap">
                    {t.name}
                  </p>
                  <p className="text-[11px] text-foreground-400 mt-0.5">
                    Paciente · {t.date}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}